/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import './tableList.scss';
import axios from 'axios';

// mui table
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

function formatDateString(dateString) {
    const date = new Date(dateString);
    const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };
    return date.toLocaleDateString('en-US', options);
}

function Teammate() {
    const [referredUsers, setReferredUsers] = useState([]);
    const [referredUsersIndirect, setReferredUsersIndirect] = useState([]);
    const [lsat, setlsat] = useState(localStorage.getItem("authUser") || "");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${lsat}`,
        }
    };

    useEffect(() => {
        const fetchReferredUsers = async () => {
            try {
                const authUser = JSON.parse(localStorage.getItem("authUser"));

                if (!authUser) {
                    console.error('User not authenticated');
                    return;
                }

                let userr = authUser._id;

                 // to fetch direct  reffered  users
                const response = await axios.get(
                    // `http://localhost:3005/dashboard/getReferredUsers/${userr}`,
                    `https://portal-sanieldanproperties-api.onrender.com/dashboard/getReferredUsers/${userr}`,
                    config);

                if (response.data) {
                    const formattedUsers = response.data.map(user => ({
                        ...user,
                        dateOfReg: formatDateString(user.dateOfReg)
                    }));
                    setReferredUsers(formattedUsers);
                }
                // to fetch indirect  reffered  users
                // Extract referred users' details from the response
                // Make a GET request to the backend endpoint
                const dataresponse = await axios.get(
                    // `http://localhost:3005/dashboard/user-referrals/${userr}`
                    `https://portal-sanieldanproperties-api.onrender.com/dashboard/user-referrals/${userr}`,
                );

                // Extract referred users' details from the response
                const referredUsersDetails = dataresponse.data;

                // Log the retrieved data (for debugging)
                console.log("Referred users' details:", referredUsersDetails);
                setReferredUsersIndirect(referredUsersDetails)




            } catch (error) {
                console.error('Error fetching referred users:', error);
            }
        };

        fetchReferredUsers();
    }, []);

    return (
       <section className='container'>




<h1 className='font-bold text-3xl mt-10 text-left'>Direct Refferals</h1>
<div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-10">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>

                <th scope="col" class="px-6 py-3">
                Date of Reg
                </th>
                <th scope="col" class="px-6 py-3">
                    Name
                </th>
                <th scope="col" class="px-6 py-3">
                Mobile No
                </th>
                <th scope="col" class="px-6 py-3">
                Username
                </th>
                <th scope="col" class="px-6 py-3">
                    Email
                </th>
            </tr>
        </thead>
        <tbody>
        {referredUsers.map((row) => (
            <tr key={row.uniqueId} class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">

                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                {row.dateOfReg}
                </th>
                <td class="px-6 py-4">
                {row.name}
                </td>
                <td class="px-6 py-4">
                {row.mobileNo}
                </td>
                <td class="px-6 py-4">
                {row.username}
                </td>
                <td class="px-6 py-4">
                {row.email}
                </td>

            </tr>
         ))}
        </tbody>
    </table>
</div><br/>

<h1 className='font-bold text-3xl text-left mt-5'>InDirect Refferals</h1>

<div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-10">

    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>

                <th scope="col" class="px-6 py-3">
                Date of Reg
                </th>
                <th scope="col" class="px-6 py-3">
                    Name
                </th>
                <th scope="col" class="px-6 py-3">
                Mobile No
                </th>
                <th scope="col" class="px-6 py-3">
                Username
                </th>
                <th scope="col" class="px-6 py-3">
                    Email
                </th>
            </tr>
        </thead>
        <tbody>
        {referredUsersIndirect.map((row) => (
            <tr key={row.uniqueId} class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">

                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                {row.dateOfReg}
                </th>
                <td class="px-6 py-4">
                {row.name}
                </td>
                <td class="px-6 py-4">
                {row.mobileNo}
                </td>
                <td class="px-6 py-4">
                {row.username}
                </td>
                <td class="px-6 py-4">
                {row.email}
                </td>

            </tr>
         ))}
        </tbody>
    </table>
</div>




       </section>
    );
}

export default Teammate;
